import 'react';
import 'bootstrap';

import 'jquery';

import './fonts/Inter-Regular.ttf';
import './jquery';
import './notifications';
import './maintanance';

import { Tooltip, Toast, Popover, Carousel, Alert, Button, Collapse, Dropdown, Modal, Offcanvas, ScrollSpy, Tab } from 'bootstrap';
import "@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf";
import "@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf";
import "@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf";
import "@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2";
import "@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2";
import "@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2";


$(function() {
    $("[data-bs-toggle=popover]").popover();
});
